import { useMutation } from '@tanstack/react-query';
import request from '@utils/request';
import { Dispatch, SetStateAction } from 'react';

export const useApplyVoucherCode = (
  propertyId: number,
  basketId: string,
  onSuccess: () => Promise<void>,
  setError: Dispatch<SetStateAction<string | null>>
) => {
  return useMutation({
    mutationFn: async (code: string) => {
      const encodedCode = encodeURIComponent(code.trim());
      return await request.v2.post(`${propertyId}/baskets/${basketId}/vouchers`, {
        data: {
          _type: 'basket',
          code: encodedCode,
        },
      });
    },
    onSuccess,
    onError: () => {
      setError('basket.errorApplyingCodeInvalid');
    },
  });
};
